// import { Api } from 'yxt-biz-pc-base';
// const { rewardApi } = Api;
import { rewardApi, sspApi } from 'yxt-biz-pc/packages/api';
// 已获得勋章数
export const getUserMedalCount = (orgId, userId) => {
  return rewardApi.get(`/user/medal/label?orgId=${orgId}&userId=${userId}`);
};

// 已获得勋章列表
export const getMedalDetailList = (orgId, userId) => {
  return rewardApi.get(`/user/medal/detail/list?orgId=${orgId}&userId=${userId}`);
};

// 已获得等级经验值
export const getUserLevel = (data) => {
  return rewardApi.post('/user/exp/level/label', data);
};

// 记录Im信息
export const setImLog = data => {
  return rewardApi.post('/reward/log/im_message', data);
};

export const getHourContinuityDays = (days, userId) => {
  return sspApi.get(`/foreign/hour/continuity/days?days=${days}&userId=${userId}`);
};
